import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { ImageCropper } from "../components/imagecropper";
import { userState } from "../Services/RecoilAtoms";
import Swal from "sweetalert2";
import {
  AdminCreateProducts,
  AdminUpdateSingleProduct,
  AdminViewSingleProduct,
  ViewAdminBrands,
  getCategories,
} from "../utils/Api/ApiCalls";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditProduct = () => {
  const { register, handleSubmit, setValue } = useForm();
  const { id } = useParams();
  const currentUser = useRecoilValue(userState);
  const [brandData, setBrandData] = useState([]);
  const [singleData, setSingleData] = useState({});
  const navigate = useNavigate();

  const [categoryData, setCategoryData] = useState({
    categories: [],
    subCategories: [],
    brands: [],
  });
  const [brands, setBrands] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [parsed, setParsed] = useState("");
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [load, setLoad] = useState(false);
  const [data, setData] = useState({
    currency: "",
  });
  const [formData, setFormData] = useState({
    productTitle: "",
    fullDesc: "",
    regularPrice: "",
    promotionalPrice: "",
    currency: "",
    category: "",
    subcategory: "",
    brand: "",
    label: "",
    images: null,
  });

  useEffect(() => {
    if (singleData && Object.keys(singleData).length > 0) {
      setFormData((prev) => ({
        ...prev,
        productTitle: singleData.productTitle || "",
        fullDesc: singleData.fullDesc || "",
        regularPrice: singleData.regularPrice || "",
        promotionalPrice: singleData.promotionalPrice || "",
        currency: singleData.currency || "",
        category: singleData.category || "",
        subcategory: singleData.subcategory || "",
        brand: singleData.brand || "",
        label: singleData.label || "",
        images: singleData.images || null,
      }));
    }
  }, [singleData]);

  const ViewAllBrands = async () => {
    try {
      const response = await ViewAdminBrands(
        currentUser.data.info.id,
        currentUser.data.token
      );
      setBrandData(response.data);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", html: err?.response?.data?.html || err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  const removeLabel = (e) => {
    e.preventDefault();
    setFormData((prev) => ({ ...prev, label: " " }));
    setSingleData((prev) => ({...prev, label: " "}))
  }

  const FetchingSingleProduct = async () => {
    try {
      const response = await AdminViewSingleProduct(id);
      if (response.data) {
        setSingleData(response.data);
        setParsed(response?.data?.fullDesc);
      }
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", html: err?.response?.data?.html || err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };
  useEffect(() => {
    //ViewAllBrands();
    GetAllCategories();
    FetchingSingleProduct();
  }, []);
  const GetAllCategories = async () => {
    try {
      const response = await getCategories();
      if (response) {
        setCategoryData(response);
        onCategoryChange();
      }
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", html: err?.response?.data?.html || err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  const OnHandleChange = async (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const avatarFile = files[0];

      const resizedImageBlob = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxWidth = 10;
            const maxHeight = 10;

            let newWidth = img.width;
            let newHeight = img.height;

            if (img.width > maxWidth || img.height > maxHeight) {
              const aspectRatio = img.width / img.height;

              if (img.width > img.height) {
                newWidth = maxWidth;
                newHeight = maxWidth / aspectRatio;
              } else {
                newHeight = maxHeight;
                newWidth = maxHeight * aspectRatio;
              }
            }

            canvas.width = newWidth;
            canvas.height = newHeight;

            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            canvas.toBlob((blob) => {
              resolve(blob);
            }, avatarFile.type);
          };
        };

        reader.readAsDataURL(avatarFile);
      });

      setPreviewImageUrl(URL.createObjectURL(resizedImageBlob));

      setFormData((prev) => ({
        ...prev,
        ["images"]: resizedImageBlob,
      }));
    } else {
      setFormData((prevProfile) => ({
        ...prevProfile,
        [name]: value,
        // attributes: attributes,
      }));
    }
  };

  const UpdateProducts = async () => {
    setFormData((prevData) => ({
      ...prevData,
      fullDesc: parsed,
      // attributes: attributes,
    }));
    setLoad(true);
    console.log(formData);

    try {
      const response = await AdminUpdateSingleProduct(id, formData);

      setLoad(false);

      if (response.status == 200) {
        Swal.fire({
          title: "Product updated Successfully",
          icon: "success",
        }).then(() => {
          // window.location.reload();
          navigate("/products");
        });
      } else {
        Swal.fire({
          title: "Product failed to update.",
          icon: "error",
        }).then(() => {
          // window.location.reload();
        });
      }
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", html: err?.response?.data?.html || err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };
  const onSubCategoryChange = (e) => {
    const { name, value } = e.target;
    let data = categoryData.brands.filter(
      (item, i) => item.subCategoryId === parseInt(value)
    );
    setBrands(data[0].brandName.split(","));
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onGetSubCategory = (selected) => {
    let category = categoryData?.categories?.filter(
      (item) => item.categoryName === selected
    );
    let data = categoryData.subCategories.filter(
      (item, i) => item.categoryId === parseInt(category[0].ID)
    );
    setSubCategories(data);
  };
  const onCategoryChange = (e) => {
    setSubCategories([]);
    const { name, value } = e.target;
    let data = categoryData.subCategories.filter(
      (item, i) => item.categoryId === parseInt(value)
    );
    setSubCategories(data);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const setCategoryDefault = (value) => {
    let data = categoryData.categories.filter(
      (item, i) => item.categoryName === parseInt(value)
    );
    return data[0].categoryName;
  };
  const options = [
    { value: "C++", label: "C++" },
    { value: "JAVA", label: "JAVA" },
    { value: "Javascript", label: "Javascript" },
    { value: "Python", label: "Python" },
    { value: "Swift", label: "Swift" },
  ];
  const OnCurrencyHandleChange = (value) => {
    //  setData((prev) => ({
    //   ...prev,
    //   currency: value
    //  }))
  };

  const handleDesChange = (value) => {
    console.log(value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      fullDesc: value,
    }));
    setParsed(value);
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  // const addField = (e) => {
  //   e.preventDefault();

  //   setAttributes([...attributes, { key: "", description: "" }]);
  // };

  // const removeField = (index, e) => {
  //   e.preventDefault();

  //   setAttributes(attributes.filter((_, i) => i !== index));
  // };

  // const handleAttributeChange = (index, event) => {
  //   const { name, value } = event.target;
  //   const updatedAttributes = [...attributes];
  //   updatedAttributes[index][name] = value;
  //   setAttributes(updatedAttributes);
  // };

  const onSelectDefaultCategory = (selected) => {
    if (singleData?.category === selected) {
      onGetSubCategory(selected);
      return true;
    }
    return false;
  };
  return (
    <section class="content-main">
      <div class="row">
        <div class="col-9">
          <div class="content-header">
            <h2 class="content-title">Update Product</h2>
            <div>
              {load ? (
                <button disabled class="btn btn-md rounded font-sm hover-up">
                  Loading...
                </button>
              ) : (
                <button
                  onClick={UpdateProducts}
                  class="btn btn-md rounded font-sm hover-up"
                >
                  Publish
                </button>
              )}
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card mb-4">
            <div class="card-header">
              <h4>Basic</h4>
            </div>
            <div class="card-body">
              <form>
                <div class="mb-4">
                  <label for="product_name" class="form-label">
                    Product title
                  </label>
                  <input
                    defaultValue={singleData?.productTitle}
                    name="productTitle"
                    onChange={OnHandleChange}
                    type="text"
                    placeholder="Type here"
                    class="form-control"
                    id="product_name"
                  />
                </div>
                <div class="mb-4">
                  <label for="product_label" class="form-label">
                    Label
                  </label>
                  <div className="d-flex gap-5">
                  <input
                    defaultValue={singleData?.label}
                    name="label"
                    onChange={OnHandleChange}
                    type="text"
                    placeholder="Eg. Discount, Black Friday, Trending, Hot deals..."
                    class="form-control"
                    id="product_label"
                  />

                  <button
                    onClick={removeLabel}
                    class="btn btn-md rounded font-sm hover-up"
                    style={{ textWrap: "no-wrap"}}
                  >
                    Remove label
                  </button>
                  </div>
                </div>
                {/* <div className="row align-items-center justify-content-around">
                  {attributes && attributes.length > 0
                    ? attributes.map((attribute, index) => {
                        return (
                          <div className="row align-items-center" key={index}>
                            <div className="col-lg-4">
                              <div className="mb-4">
                                <label className="form-label">
                                  Key
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <div className="row gx-2">
                                  <input
                                    name="key"
                                    value={attribute.key}
                                    onChange={(e) =>
                                      handleAttributeChange(index, e)
                                    }
                                    type="text"
                                    className="form-control"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <div className="mb-4">
                                <label className="form-label">
                                  Description
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  name="description"
                                  value={attribute.description}
                                  onChange={(e) =>
                                    handleAttributeChange(index, e)
                                  }
                                  type="text"
                                  className="form-control"
                                />
                              </div>
                            </div>
                            <button
                              className="col-lg-3 btn btn-md rounded font-sm hover-up"
                              onClick={(e) => removeField(index, e)}
                            >
                              Remove
                            </button>
                          </div>
                        );
                      })
                    : "Add a new field."}

                  <button
                    className="col-lg-3 btn btn-md btn-w-auto rounded font-sm hover-up"
                    onClick={(e) => addField(e)}
                  >
                    Add +
                  </button>
                </div> */}
                <div class="mb-4">
                  <label class="form-label">Full description</label>
                  {/* <textarea
                    defaultValue={singleData?.fullDesc}
                    name="fullDesc"
                    onChange={OnHandleChange}
                    placeholder="Type here"
                    class="form-control"
                    rows="4"
                  ></textarea> */}

                  {/* {parsed ? ( */}
                  <div className="ql-container">
                    <ReactQuill
                      value={parsed}
                      onChange={handleDesChange}
                      modules={modules}
                      formats={formats}
                      style={{ height: "320px", marginBottom: "50px" }}
                      theme="snow"
                    />
                  </div>
                  {/* ) : (
                    <div className="loading">Loading...</div>
                  )} */}
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="mb-4 col-lg-4">
                      <label class="form-label">Quantity</label>
                      <div class="row gx-2">
                        <input
                          defaultValue={singleData?.quantity}
                          name="quantity"
                          onChange={OnHandleChange}
                          placeholder="0"
                          type="number"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="mb-4">
                      <label class="form-label">Regular price</label>
                      <div class="row gx-2">
                        <input
                          defaultValue={singleData?.regularPrice}
                          name="regularPrice"
                          onChange={OnHandleChange}
                          placeholder="₦"
                          type="number"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="mb-4">
                      <label class="form-label">Promotional price</label>
                      <input
                        defaultValue={singleData?.promotionalPrice}
                        name="promotionalPrice"
                        onChange={OnHandleChange}
                        placeholder="₦"
                        type="number"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">Currency</label>
                    {/* <select
                      // defaultValue={formData.currency || singleData.currency || '--select--'}
                      defaultValue={singleData?.currency}
                      defaultChecked={singleData?.currency}
                      name="currency"
                      onChange={OnHandleChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      <option value="NGN">NGN</option>
                    </select> */}
                    <Select
                      callback={OnCurrencyHandleChange}
                      values={["FCFA", "NGN"]}
                      key={"currency"}
                      selected={singleData?.currency}
                    />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Category<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      id="category"
                      name="category"
                      onChange={onCategoryChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {categoryData?.categories?.map((item, i) => (
                        <option key={"category" + i} value={item.ID}>
                          {item.categoryName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Sub Category<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="subcategory"
                      id="subcategory"
                      onChange={onSubCategoryChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {subcategories?.map((item, i) => (
                        <option key={"subcategory" + i} value={item.ID}>
                          {item.subCategoryName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Brand<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="brand"
                      onChange={OnHandleChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {brands?.map((name, i) => (
                        <option key={"brand" + i} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* <div class="col-lg-4">
                    <label class="form-label">
                      Category<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      id="category"
                      name="category"
                      onChange={onCategoryChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {categoryData?.categories?.map((item, i) => (
                        <option key={"category" + i} value={item.ID} selected={singleData?.category === item.categoryName}>{item.categoryName}</option>
                      ))}
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Sub Category<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="subcategory"
                      id="subcategory"
                      onChange={onSubCategoryChange}
                      class="form-select"
                      defaultValue={singleData?.subcategory}
                      defaultChecked={singleData?.subcategory}
                    >
                      <option>--select--</option>
                      {subcategories?.map((item, i) => (
                        <option key={"subcategory" + i} value={item.ID} selected={singleData?.subcategory === item.subCategoryName}>{item.subCategoryName}</option>
                      ))}
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Brand<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="brand"
                      onChange={OnHandleChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {brands?.map((name, i) => (
                        <option key={"brand" + i} value={name}>{name}</option>
                      ))}
                    </select>
                  </div> */}
                </div>
                {/* <div class="mb-4">
                              <label class="form-label">Tax rate</label>
                              <input type="text" placeholder="%" class="form-control" id="product_name" />
                          </div> */}
                {/* <label class="form-check mb-4">
                              <input class="form-check-input" type="checkbox" value="" />
                              <span class="form-check-label"> Make a template </span>
                          </label> */}
              </form>
            </div>
          </div>

          {/* <div class="card mb-4">
                  <div class="card-header">
                      <h4>Shipping</h4>
                  </div>
                  <div class="card-body">
                      <form>
                          <div class="row">
                              <div class="col-lg-6">
                                  <div class="mb-4">
                                      <label for="product_name" class="form-label">Width</label>
                                      <input
                                          type="text"
                                          placeholder="inch"
                                          class="form-control"
                                          id="product_name"
                                      />
                                  </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="mb-4">
                                      <label for="product_name" class="form-label">Height</label>
                                      <input
                                          type="text"
                                          placeholder="inch"
                                          class="form-control"
                                          id="product_name"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div class="mb-4">
                              <label for="product_name" class="form-label">Weight</label>
                              <input type="text" placeholder="gam" class="form-control" id="product_name" />
                          </div>
                          <div class="mb-4">
                              <label for="product_name" class="form-label">Shipping fees</label>
                              <input type="text" placeholder="₦" class="form-control" id="product_name" />
                          </div>
                      </form>
                  </div>
              </div> */}
        </div>
        <div class="col-lg-5">
          <div class="card mb-4">
            <div class="card-header">
              <h4>Media</h4>
            </div>
            <div class="card-body">
              <div class="">
                <ImageCropper
                  onCropped={(blob) =>
                    setFormData((prev) => ({
                      ...prev,
                      images: blob,
                    }))
                  }
                />
                {/* {previewImageUrl !== "" ? (
                  <img src={previewImageUrl} alt="" />
                ) : (
                  <img src="assets/imgs/theme/upload.svg" alt="" />
                )}
                <input
                  required
                  onChange={OnHandleChange}
                  name="images"
                  class="form-control"
                  type="file"
                /> */}
              </div>
            </div>
          </div>

          {/* <div class="card mb-4">
                  <div class="card-header">
                      <h4>Organization</h4>
                  </div>
                  <div class="card-body">
                      <div class="row gx-2">
                          <div class="col-sm-6 mb-3">
                              <label class="form-label">Category</label>
                              <select class="form-select">
                                  <option>Automobiles</option>
                                  <option>Home items</option>
                                  <option>Electronics</option>
                                  <option>Smartphones</option>
                                  <option>Sport items</option>
                                  <option>Baby and Tous</option>
                              </select>
                          </div>
                          <div class="col-sm-6 mb-3">
                              <label class="form-label">Sub-category</label>
                              <select class="form-select">
                                  <option>Nissan</option>
                                  <option>Honda</option>
                                  <option>Mercedes</option>
                                  <option>Chevrolet</option>
                              </select>
                          </div>
                          <div class="mb-4">
                              <label for="product_name" class="form-label">Tags</label>
                              <input type="text" class="form-control" />
                          </div>
                      </div>
                 
                  </div>
              </div> */}

          {/* <div class="card mb-4">
                  <div class="card-header">
                      <h4>Sales</h4>
                  </div>
                  <div class="card-body">
                      <div class="row gx-2">
                          <div class="mb-3">
                              <label class="form-label">Mark product as</label>
                              <select class="form-select">
                                  <option>Sale</option>
                                  <option>Best</option>
                                  <option>Hot</option>
                              </select>
                          </div>
                          <div class="mb-4">
                              <label class="form-label">Percentage off</label>
                              <input type="text" class="form-control" />
                          </div>
                      </div>
                
                  </div>
              </div> */}
        </div>
      </div>
    </section>
  );
};

export default EditProduct;

const Select = ({ values, callback, selected }) => {
  return (
    <select
      // disabled={disabled}
      // readOnly={readonly}
      className="form-select"
      onChange={({ target: { value } }) => callback(value)}
    >
      {values.map((value) => (
        <option selected={selected === value} value={value}>
          {value}
        </option>
      ))}
    </select>
  );
};
